// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		name: '杨勇',
		obj:'YBJZ20241011510701',
		type:'身份证',
		idCard:'5115897456885686320',
		creater:'admin',
		sex:'男',
		tel:'13366987412',
		date: '2015-05-21 | 00：00：00',
		createDate: '2015-05-21 | 00：00：00',
		from: '九阵',
		grade:"超级客户",
		icon:"el-icon-medal-1",
		city: '宜宾市',
		address: '宜宾市临港经济区化工路70号邦泰临港国际12栋1单元104号',
		vip: '免费七天体验',
	  },
	{
		name: '古沿宏',
		obj:'YBJZ20241010100702',
		type:'身份证',
		idCard:'5115897456885686320',
		creater:'admin',
		sex:'男',
		tel:'13366987412',
		date: '2015-05-21 | 00：00：00',
		createDate: '2015-05-21 | 00：00：00',
		from: '抖音',
		grade:"一般客户",
		icon:"el-icon-user",
		city: '宜宾市',
		address: '宜宾市临港经济区化工路70号邦泰临港国际12栋1单元104号',
		vip: '免费七天体验',
	  },
		{
			name: '张培东',
			obj:'YBJZ20241010101103',
			type:'身份证',
			idCard:'5115021999465238966',
			creater:'admin',
			sex:'男',
			tel:'13599833246',
			date: '1994-06-06 | 00：00：00',
			createDate: '2015-05-21 | 00：00：00',
			from: '销售',
			grade:"老板/老板娘",
			icon:"el-icon-umbrella",
			city: '宜宾市',
			address: '宜宾市南溪区104号',
			vip: '永久',
		  },
		{
			name: '杨世江',
			obj:'YBJZ20241010101304',
			type:'身份证',
			idCard:'51158974533211159',
			creater:'admin',
			sex:'男',
			tel:'13366987412',
			date: '2015-05-21 | 00：00：00',
			createDate: '2015-05-21 | 00：00：00',
			from: '销售',
			grade:"会员客户",
			icon:"el-icon-medal",
			city: '宜宾市',
			address: '云南省水富市高滩坝云富街道水富市人民医院信息科001号',
			vip: '一个月',
          },
		{
			name: '吴笙榕',
			obj:'YBJZ20241010100705',
			type:'身份证',
			idCard:'5115897456885686320',
			creater:'admin',
			sex:'女',
			tel:'13366987412',
			date: '2015-05-21 | 00：00：00',
			createDate: '2015-05-21 | 00：00：00',
			from: '抖音',
			grade:"会员客户",
			icon:"el-icon-medal",
			city: '宜宾市',
			address: '云南省水富市高滩坝云富街道水富市人民医院信息科003号',
			vip: '三个月',
          },
		  {
			name: '陈南',
			obj:'YBJZ20241010100706',
			type:'身份证',
			idCard:'5115897456885686320',
			creater:'admin',
			sex:'男',
			tel:'13366987412',
			date: '2015-05-21 | 00：00：00',
			createDate: '2015-05-21 | 00：00：00',
			from: '抖音',
			grade:"一般客户",
			icon:"el-icon-user",
			city: '宜宾市',
			address: '宜宾市南溪区105号',
			vip: '半年',
			},

]

